import { fetchApi, ADMIN_API } from '@/api/client'
import type { TopicMessage } from '../types/topology'

export async function getTopicMessages(topic: string, limit = 500): Promise<TopicMessage[]> {
  return fetchApi<TopicMessage[]>(
    `${ADMIN_API}/pipeline/topic-messages?topic=${encodeURIComponent(topic)}&limit=${limit}`
  )
}
